// extracted by mini-css-extract-plugin
export default {"title":"List_title__-W12+","titleContainer":"List_titleContainer__FYSd6","listItems":"List_listItems__+zDzp"};